import { useParams } from 'react-router-dom';
// components
import Page from 'src/components/Page';

// paginas
import Campanhas from 'src/pages/chats/Campanhas';
import MensagensAgendadas from 'src/pages/chats/MensagensAgendadas';
import MarketingRastreamento from './MarketingRastreamento';
import MarketingMetricas from './MarketingMetricas';

// social analytics
import MktAnalytics from 'src/sections/@dashboard/marketing/analytics';

// publicacoes (Facebook/Instagram)
import MktPosts from 'src/sections/@dashboard/marketing/posts';
import MktPostPage from 'src/sections/@dashboard/marketing/posts/MktPostPage';

// anuncios Meta Ads (ads_read + pages_manage_ads)
import MktAds from 'src/sections/@dashboard/marketing/anuncios';
import MktAdPage from 'src/sections/@dashboard/marketing/anuncios/MktAdPage';
import MktCtwaPage from 'src/sections/@dashboard/marketing/ctwa';

import CampanhaDetalhes from 'src/pages/chats/campanhas/CampanhaDetalhes';

import MarketingSidebar from 'src/sections/@dashboard/marketing/MarketingSidebar/MarketingSidebar';

export default function Marketing() {
  // postId / adId / campanhaId existem nas rotas com 4 segmentos
  // (marketing/publicacoes/:postId, marketing/anuncios/:adId,
  // marketing/campanhas/:campanhaId) — nesse caso `label` vem undefined.
  const { label, postId, adId, campanhaId } = useParams();

  return (
    <div className="flex w-full overflow-hidden h-[calc(100vh-64px)] lg:h-[calc(100vh-55px)]">
      <MarketingSidebar />

      {/* Métricas costumava gerenciar seu proprio scroll interno (header fixo +
          regiao flex-1 overflow-y-auto), o que forcava este overflow-hidden
          como caso especial so pra ela. Migrada para fluxo normal como as
          demais paginas da secao — nao precisa mais de tratamento a parte. */}
      <main className="flex-1 w-full min-w-0 overflow-x-hidden overflow-y-auto relative">
        <div className="min-h-full w-full h-full">
          {label === "campanhas" && !campanhaId && <Campanhas />}
          {campanhaId && <CampanhaDetalhes />}
          {label === "agendamentos" && <MensagensAgendadas />}
          {label === "rastreamento" && <MarketingRastreamento />}
          {label === "metricas" && <MarketingMetricas />}
          {label === "analytics" && <MktAnalytics />}
          {label === "publicacoes" && <MktPosts />}
          {label === "anuncios" && <MktAds />}
          {label === "ctwa" && <MktCtwaPage />}
          {postId && <MktPostPage postId={postId} />}
          {adId && <MktAdPage adId={adId} />}
        </div>
      </main>
    </div>

  );
}
